import {BilledConsumption, Movement, Output, RatePlanItem} from '../contexts/Configuration';

// Only `textOnly` (and the array length) are needed to price outputs, so accept a minimal
// shape. This lets two-way callers pass lightweight panel-derived entries without building
// full `Output` objects (see BalanceSummary).
export const calculateAvailableMinutes = (outputs: { textOnly?: boolean }[], ratePlanItems: RatePlanItem[], currentBalance: number): string => {
    if(ratePlanItems === undefined || ratePlanItems.length === 0)
        return "";

    const ratePlanItemMap = ratePlanItems.reduce((map: { [key: string]: number }, item) => {
        map[item.code] = item.price;
        return map;
    }, {});

    // console.log(ratePlanItemMap)

    if (outputs.length === 0) {
        const captionsPrice = ratePlanItemMap['CAPTIONS_FOR_INPUT_LANG'];
        const totalMin = Math.round(currentBalance / captionsPrice).toFixed(0);
        console.log(
            '[AvailableMinutes] Captions-only (0 outputs):\n' +
            `  balance              = ${currentBalance}\n` +
            `  CAPTIONS_FOR_INPUT_LANG (price/min) = ${captionsPrice}\n` +
            `  => total minutes     = round(${currentBalance} / ${captionsPrice}) = ${totalMin}`
        );
        return totalMin;
    }
    const outputsWithTextOnly = outputs.filter(o => o.textOnly).length;
    const outputsWithTranslation = outputs.length - outputsWithTextOnly;

    const textOnlyUnitPrice = ratePlanItemMap['TEXT_ONLY_TRANSLATION'];
    const translationUnitPrice = ratePlanItemMap['AUDIO_TRANSLATION'];

    const textOnlyPrice = outputsWithTextOnly * textOnlyUnitPrice;
    const translationsPrice = outputsWithTranslation * translationUnitPrice;
    const pricePerMinute = textOnlyPrice + translationsPrice;

    const total = Math.round(currentBalance / pricePerMinute).toFixed(0);
    console.log(
        `[AvailableMinutes] ${outputs.length} 'completed' output(s):\n` +
        `  text-only outputs    = ${outputsWithTextOnly} x ${textOnlyUnitPrice} (TEXT_ONLY_TRANSLATION) = ${textOnlyPrice}\n` +
        `  audio outputs        = ${outputsWithTranslation} x ${translationUnitPrice} (AUDIO_TRANSLATION)    = ${translationsPrice}\n` +
        `  price/min            = ${textOnlyPrice} + ${translationsPrice} = ${pricePerMinute}\n` +
        `  balance              = ${currentBalance}\n` +
        `  => total minutes     = round(${currentBalance} / ${pricePerMinute}) = ${total}`
    );
    return total;
}

export const getBilledConsumptions = (billedConsumptions: BilledConsumption[] | undefined) => {
    if (!billedConsumptions || !billedConsumptions.length)
        return '';

    return billedConsumptions.map(billedConsumption => {
        return billedConsumption.ratePlantItemName + '-' + billedConsumption.lang + ':' + billedConsumption.amount;
    }).join(';');
}

export const downloadCSV = (rows: string[], title: string) => {
    const csvContent = 'data:text/csv;charset=utf-8,' + rows.join('');
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', title);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}